import {
	EdgerRollPass,
	EdgerRollPassResponse,
} from "@/pages/catalogs/models/EdgerRoll";
import { Roll } from "@/shared/models/Roll";
import { getMomentTz, MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";

const moment = getMomentTz();

export const getBrokenRolls = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[M2].[GetBrokenRolls]", [], signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching broken rolls");
	}

	const rows = get(resp, "data.tables[0].rows", []) as Roll[];
	const passRows = get(
		resp,
		"data.tables[1].rows",
		[],
	) as EdgerRollPassResponse[];

	const groupPasses = (edgerRollPartId: number): EdgerRollPass[] => {
		const passMap = new Map<number, EdgerRollPass>();

		passRows
			.filter((r) => r.EdgerRollPartId === edgerRollPartId)
			.forEach((r) => {
				if (!passMap.has(r.PassNumber)) {
					passMap.set(r.PassNumber, {
						PassNumber: r.PassNumber,
						PassStatusCode: r.PassStatusCode,
						StatusDescription: r.StatusDescription,
						Sections: [],
					});
				}

				const pass = passMap.get(r.PassNumber);
				if (pass && r.SectionId && r.SectionName) {
					pass.Sections.push({
						SectionId: r.SectionId,
						SectionName: r.SectionName,
					});
				}
			});

		return Array.from(passMap.values());
	};

	return rows.map((roll) => ({
		...roll,
		Passes: groupPasses(roll.PartId),
		BrokenAt: roll.BrokenAt ? moment.utc(roll.BrokenAt).toDate() : null,
	}));
};
